export default "__VITE_ASSET__DyWJcxfd__"